import type {RebaseState} from '../../../hooks/mutations/use-stack-rebase-mutation'
import {RebaseFailedLabel} from './rebase-state-labels/RebaseFailedLabel'
import {MergeConflictsLabel} from './rebase-state-labels/MergeConflictsLabel'
import {RebasedLabel} from './rebase-state-labels/RebasedLabel'
import {RebasingLabel} from './rebase-state-labels/RebasingLabel'
import {SkippedLabel} from './rebase-state-labels/SkippedLabel'

export function RebaseStateLabel(props: {state?: RebaseState}) {
  return (
    <>
      <RebasingLabel {...props} />
      <RebasedLabel {...props} />
      <MergeConflictsLabel {...props} />
      <RebaseFailedLabel {...props} />
      <SkippedLabel {...props} />
    </>
  )
}
